// SPDX-License-Identifier: AGPL-3.0-or-later

import {GenericErrorModal} from '@app/features/app/components/alerts/GenericErrorModal';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
export const RoleUpdateFailedModal = observer(() => {
	const {t} = useLingui();
	return (
		<GenericErrorModal
			title={t`Failed to Update Roles`}
			message={t`We couldn't save your role changes at this time.`}
		/>
	);
});
